import { doodBlockConfig, propertyValue } from './dood-block-config';
import {
  buildOrderedBlockDescriptor,
  type DescriptorFieldOrderItem,
} from './descriptor-field-order';
import type { IBlockDescriptor } from './descriptor';

export const HEROCARDCAROUSELBLOCK_LEGACY_FIELD_ORDER = [
  "heading",
  "content",
  "link_url",
  "link_target",
  "background_image",
  "text_color",
  "background_color"
] as const satisfies readonly DescriptorFieldOrderItem[];

const {
  heroCardCarouselBlockDescriptor: _generatedHeroCardCarouselBlockDescriptor,
  heroCardCarouselBlockBlocDefinition,
  heroCardCarouselBlockDashboardLayout,
  heroCardCarouselBlockConfig,
  heroCardCarouselBlockResolveConfig,
  heroCardCarouselBlockProperties,
} = doodBlockConfig(
  {
    name: "Hero Card Carousel",
    componentType: 'HeroCardCarouselBlockComponent',
    category: 'content',
    description: "Hero Card Carousel.",
    keywords: [],
    allowedIn: [
      { bloc: "ShopHeroTemplateBlockComponent", slot: "cards" },
    ],
    sharedFields: {}
  },

  () => ({
    heading: propertyValue({
      type: 'text',
      value: '',
      options: {
        label: "pages.blocks.hero-card-carousel.heading.label",
      }
    }),
    content: propertyValue({
      type: 'wysiwyg',
      value: '',
      options: {
        label: "pages.blocks.hero-card-carousel.content.label",
      }
    }),
    link_url: propertyValue({
      type: 'link',
      value: '',
      options: {
        label: "pages.blocks.hero-card-carousel.link-url.label",
        help: "pages.blocks.hero-card-carousel.link-url.help",
      }
    }),
    link_target: propertyValue({
      type: 'select',
      value: "_self",
      options: {
        label: "pages.blocks.hero-card-carousel.link-target.label",
        help: "pages.blocks.hero-card-carousel.link-target.help",
        choices: [
          {
            value: "_self",
            label: "pages.blocks.hero-card-carousel.link-target.options._self",
          },
          {
            value: "_blank",
            label: "pages.blocks.hero-card-carousel.link-target.options._blank",
          }
        ]
      }
    }),
    background_image: propertyValue({
      type: 'image',
      value: '',
      options: {
        label: "pages.blocks.hero-card-carousel.background-image.label",
        help: "pages.blocks.hero-card-carousel.background-image.help",
      }
    }),
    text_color: propertyValue({
      type: 'color',
      value: {"type":"palette","value":"neutral-800"},
      options: {
        label: "pages.blocks.hero-card-carousel.text-color.label",
      }
    }),
    background_color: propertyValue({
      type: 'color',
      value: {"type":"hex","value":"#FFFFFF"},
      options: {
        label: "pages.blocks.hero-card-carousel.background-color.label",
      }
    })
  }),

  () => ({
    tabs: [
      {
        label: "pages.blocks.hero-card-carousel.tab.content.label",
        fieldsets: [
          {
            legend: "pages.blocks.hero-card-carousel.fieldset.title.label",
            fields: ["heading", "text_color"],
          },
          {
            legend: "pages.blocks.hero-card-carousel.fieldset.content.label",
            fields: ["content"],
          },
          {
            legend: "pages.blocks.hero-card-carousel.fieldset.link.label",
            fields: ["link_url", "link_target"],
          },
          {
            legend: "pages.blocks.hero-card-carousel.fieldset.image.label",
            fields: ["background_image", "background_color"],
          },
        ],
      },
    ],
  })
);

export function heroCardCarouselBlockDescriptor(): IBlockDescriptor;
export function heroCardCarouselBlockDescriptor(
  fieldOrder: readonly DescriptorFieldOrderItem[],
): IBlockDescriptor;
export function heroCardCarouselBlockDescriptor(
  fieldOrder?: readonly DescriptorFieldOrderItem[],
): IBlockDescriptor {
  if (fieldOrder === undefined) {
    return _generatedHeroCardCarouselBlockDescriptor;
  }
  return buildOrderedBlockDescriptor(_generatedHeroCardCarouselBlockDescriptor, heroCardCarouselBlockProperties, fieldOrder);
}

export {
  heroCardCarouselBlockBlocDefinition,
  heroCardCarouselBlockDashboardLayout,
  heroCardCarouselBlockProperties,
  heroCardCarouselBlockConfig,
  heroCardCarouselBlockResolveConfig,
};

export type HeroCardCarouselBlockConfig = typeof heroCardCarouselBlockConfig;
